export default "__VITE_ASSET__Dxa$e6eZ__"